module.exports = __webpack_public_path__ + "static/media/18_3.7b90488e.jpg";